module.exports = __webpack_public_path__ + "static/media/companyHub-donate.dc227484.png";